import { cn } from '~/utils/tailwind-utils'

export const COMMAND_PANEL_CLASS = cn(
  'flex flex-col overflow-hidden bg-white text-primary dark:bg-black',
  'border border-black/25 dark:border-white/10',
  'shadow-3xl z-40 h-full max-h-96 w-full max-w-md rounded-xl focus-visible:outline-0',
)
